import React from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  CompassColor,
  Image,
  Stack,
  Text,
} from "@noom/wax-component-library";

import { type ProgramResultValueProp, useProgramResult } from "@/hooks";

import { TitleText } from "./shared";

const ValuePropCard = ({
  descriptionKeySuffix,
  imageSrc,
  titleKeySuffix,
}: ProgramResultValueProp) => {
  const { t } = useTranslation();

  return (
    <Box
      backgroundColor={CompassColor.white}
      borderRadius="8px"
      boxShadow={["0px 0px 4px 1px #0000000F", "1px 2px 6px 0px #00000014"]}
      display="flex"
    >
      <Box
        display="flex"
        flexDirection="column"
        gap="var(--spacing-xs)"
        padding="var(--spacing-m)"
      >
        <Text
          fontFamily="Untitled Serif"
          fontSize="16px"
          fontWeight={500}
          lineHeight="24px"
        >
          {t(
            `programResult.descriptionSection.valueProps.title.${titleKeySuffix}`,
          )}
        </Text>
        <Text fontFamily="Untitled Sans" fontSize="16px" lineHeight="24px">
          {t(
            `programResult.descriptionSection.valueProps.description.${descriptionKeySuffix}`,
          )}
        </Text>
      </Box>
      <Box flexShrink={0}>
        <Image src={imageSrc} width="100px" />
      </Box>
    </Box>
  );
};

export const ProgramResultDescriptionSection = () => {
  const { socialProofText, valueProps } = useProgramResult();
  const { t } = useTranslation();

  return (
    <Box
      borderRadius="32px 32px 8px 8px"
      backgroundColor="#F4F4F4"
      marginTop="-32px"
      position="relative"
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <Text
          fontFamily="Untitled Serif"
          fontSize="28px"
          lineHeight="36px"
          marginTop="var(--spacing-l)"
        >
          {t("programResult.descriptionSection.heading")}
        </Text>
        <Box marginTop="var(--spacing-s)">
          <TitleText>
            {t("programResult.descriptionSection.description")}
          </TitleText>
        </Box>
        <Stack gap="var(--spacing-m)" padding="var(--spacing-m)" width="100%">
          {valueProps.map(
            ({ descriptionKeySuffix, imageSrc, titleKeySuffix }) => (
              <ValuePropCard
                key={descriptionKeySuffix}
                descriptionKeySuffix={descriptionKeySuffix}
                imageSrc={imageSrc}
                titleKeySuffix={titleKeySuffix}
              />
            ),
          )}
          <Box borderRadius="8px" backgroundColor={CompassColor.sand01}>
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
              padding="var(--spacing-m)"
            >
              <Image
                src="/assets/img/program-result-social-proof.png"
                width="124px"
              />
              <Box marginTop="var(--spacing-m)" textAlign="center">
                <Text>{socialProofText}</Text>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
